import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

import { PlaceholderCard } from "./PlaceholderCard";

const styles: StyleRulesCallback = ({ spacing: { unit } }) => ({
  container: {
    "& > *": {
      marginLeft: unit * 2
    },
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto"
  }
});

export const BasePlaceholder: React.FC<WithStyles<typeof styles>> = ({ classes }) => (
  <div className={classes.container}>
    {[...Array(5).keys()].map(index => (
      <PlaceholderCard key={index} />
    ))}
  </div>
);

export const Placeholder = withStyles(styles)(BasePlaceholder);
